export default Object.freeze({
  RESET_TO_DEFAULT_STATE: 'RESET_TO_DEFAULT_STATE',
  NOTIFICATIONS: 'NOTIFICATIONS',
  NOTIFICATIONS_NEW: 'NOTIFICATIONS_NEW',
  NOTIFICATION_READ_UPDATE: 'NOTIFICATION_READ_UPDATE',
});
